<template>
  <b-img @click="onchange" :src="src" style="height: 1.7em;"/>
</template>

<script>
export default {
  name: "CSwitch",
  props:{
    value:{
      type:String,
      default:'N',
    }
  },
  methods:{
    onchange(){
      console.log('aaa');
      let state = this.value == 'Y' ? 'N' : 'Y';
      this.$emit('input', this.value);
      this.$emit('change', state);
    }
  },
  computed:{
    src(){
      return this.value == 'Y'?
        require('../../assets/image/ic_switch_on@2x.png')
        :
        require('../../assets/image/ic_switch_off@2x.png');
    }
  },

}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/controls/CSwitch.vue